/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2019 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import '@airglow/prefab-form';

import prefabFactory from '@airglow/prefab';
import { sessionSaveError, sessionSaveSuccess } from '../../ui/toast.list';
import { selectActiveSession } from '../../common/selectors';
import { showDetails } from './prefabs';
import { updateSession } from '../actions';

const closeDetails = () => showDetails.closeAction;

const prefabs = prefabFactory({
  detailsForm: {
    type: 'form',
    autocorrect: 'immediate',
    sourceSelector: selectActiveSession,
    whenToValidate: 'submit',
    fields: {
      link: { type: 'text', regex: /[a-zA-Z][a-zA-Z\d+-.]*:\/\/[a-zA-Z\d+-.]*/, fieldName: 'urlField', required: true },
      name: { type: 'text', max: 100, required: true },
      uuid: { type: 'text' }
    },
    resetActions: [closeDetails],
    validAction: (form, values) => updateSession({ form, values }),
    errorAction: sessionSaveError,
    successActions: [
      sessionSaveSuccess,
      showDetails.closeAction
    ]
  }
});

export const { detailsForm } = prefabs;

export default prefabs;
